import React, { useEffect, useState } from "react";
import axios from "axios";
import { validateEmail } from "../../utils/utilityFunctions";

// MUI stuff
import RecordVoiceOverOutlinedIcon from "@mui/icons-material/RecordVoiceOverOutlined";
import { makeStyles } from 'tss-react/mui';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Alert from "@mui/material/Alert";

const useStyles = makeStyles({ name: "HookGlobalStyles", index: 2 })((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
  extendedIcon: {
    marginRight: 5,
  },
  feedbackButton: {
    marginLeft: 10,
  },
  feedbackText: {
    minWidth: 200,
  },
  showEmailBox: {
    display: "block",
  },
  hideEmailBox: {
    display: "none",
  },
}));

export default function FeedbackButton() {
  const [open, setOpen] = React.useState(false);
  const [feedbackText, setFeedbackText] = useState("");
  const [mustShowEmailBox, setMustShowEmailBox] = useState(false);
  const [emailText, setEmailText] = useState("");
  const [showInvalidEmail, setShowInvalidEmail] = useState(false);
  const [showSuccessBlock, setShowSuccessBlock] = useState(false);
  let pauseTimer;

  const { classes } = useStyles();

  // Clear timeout
  useEffect(() => {
    return clearTimeout(pauseTimer);
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (mustShowEmailBox && !validateEmail(emailText)) {
      // Add email to database
      setShowInvalidEmail(true);
    } else {
      setShowInvalidEmail(false);

      axios
        .post("/api/sendEmail", {
          feedbackText:
            mustShowEmailBox && validateEmail(emailText)
              ? feedbackText.concat(
                  `</br> </br> This user would like a response to their feedback here: ${emailText}`
                )
              : feedbackText,
          userEmail: emailText,
        })
        .then((response) => {
          if (response.data.status === "success") {
            alert("Message Sent.");
            setFeedbackText("");
          } else if (response.data.status === "fail") {
            alert("Message failed to send.");
          }
        });

      setShowSuccessBlock(true);
      pauseTimer = setTimeout(() => {
        setOpen(false);
        setShowSuccessBlock(false);
        clearFeedbackForm();
      }, 1000);
    }
  };

  function clearFeedbackForm() {
    setFeedbackText("");
    setEmailText("");
    setMustShowEmailBox(false);
  }

  const handleInputChange = (event) => {
    setFeedbackText(event.target.value);
  };

  const handleCheckboxChange = (event) => {
    setMustShowEmailBox(event.target.checked);
  };

  const handleEmailTextboxChange = (event) => {
    setEmailText(event.target.value);
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        size="medium"
        className={classes.feedbackButton}
        onClick={handleClickOpen}
      >
        <RecordVoiceOverOutlinedIcon className={classes.extendedIcon} />
        Feedback
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Feedback form</DialogTitle>
        <DialogContent>
          <DialogContentText component={"div"}>
            Hi, I hope you like the app.
            <br />
            I would love to hear your feedback and suggestions.
            <br />
            <ul>
              <li>What new features you would like to see?</li>
              <li>What do you like the most?</li>
              <li>Have you found a bug?</li>
            </ul>
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="feedback"
            multiline
            minRows={3}
            label="Type your feedback here"
            type="text"
            fullWidth
            required
            className={classes.feedbackText}
            onChange={handleInputChange}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={mustShowEmailBox}
                onChange={handleCheckboxChange}
                name="responseCheckbox"
              />
            }
            label="I would like a response"
          />
          <TextField
            variant="standard"
            id="emailTextbox"
            label="Type your email address here"
            type="email"
            fullWidth
            required={mustShowEmailBox}
            onChange={handleEmailTextboxChange}
            className={
              mustShowEmailBox ? classes.showEmailBox : classes.hideEmailBox
            }
          />
          {showInvalidEmail ? (
            <Alert severity="error">Please enter a valid email.</Alert>
          ) : (
            ""
          )}
        </DialogContent>
        {showSuccessBlock ? (
          <Alert severity="success">Thanks for the feedback</Alert>
        ) : (
          ""
        )}
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} color="primary">
            Submit feedback
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
